import { render, staticRenderFns } from "./AutoTextarea.vue?vue&type=template&id=01454566&scoped=true&"
import script from "./AutoTextarea.vue?vue&type=script&lang=js&"
export * from "./AutoTextarea.vue?vue&type=script&lang=js&"
import style0 from "./AutoTextarea.vue?vue&type=style&index=0&id=01454566&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01454566",
  null
  
)

export default component.exports